export const JOB_MONITORING = {
    SSE_STALE_AFTER_S: 8,
    FALLBACK_POLL_S: 3,
    LIVE_PREVIEW_ENABLED: true,
};

export function applyJobMonitoringPolicy(policy = {}) {
    if (!policy || typeof policy !== 'object') return;
    if (policy.sse_stale_after_s != null) {
        const val = Math.max(1, Number(policy.sse_stale_after_s));
        if (!Number.isNaN(val)) {
            JOB_MONITORING.SSE_STALE_AFTER_S = val;
        }
    }
    if (policy.fallback_poll_s != null) {
        const val = Math.max(1, Number(policy.fallback_poll_s));
        if (!Number.isNaN(val)) {
            JOB_MONITORING.FALLBACK_POLL_S = val;
        }
    }
    if (policy.live_preview_enabled != null) {
        JOB_MONITORING.LIVE_PREVIEW_ENABLED = Boolean(policy.live_preview_enabled);
    }
}
